export type StyleVariant =
  | 'primary'
  | 'info'
  | 'success'
  | 'warning'
  | 'danger';
export type SelectionRangeDirection = 'none' | 'backward' | 'forward';
export type RangeTextSelectMode = 'preserve' | 'select' | 'start' | 'end';

export type TileManagerDragMode = 'none' | 'tile-header' | 'tile';
export type TileManagerResizeMode = 'none' | 'hover' | 'always';
